/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.47567.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class ApiAccountControllerApi extends runtime.BaseAPI {
    /**
     */
    async blockOwnDefaultSenderRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/block-default-sender`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async blockOwnDefaultSender(initOverrides) {
        await this.blockOwnDefaultSenderRaw(initOverrides);
    }
    /**
     */
    async checkInboxAvailableRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling checkInboxAvailable.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/check-inbox-available`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async checkInboxAvailable(requestParameters, initOverrides) {
        const response = await this.checkInboxAvailableRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createOnboardingSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.createOnboardingSubmissionOptions === null || requestParameters.createOnboardingSubmissionOptions === undefined) {
            throw new runtime.RequiredError('createOnboardingSubmissionOptions', 'Required parameter requestParameters.createOnboardingSubmissionOptions was null or undefined when calling createOnboardingSubmission.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/onboarding-submission`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createOnboardingSubmissionOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createOnboardingSubmission(requestParameters, initOverrides) {
        const response = await this.createOnboardingSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createOrUpdateUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.updateUserSettingsOptions === null || requestParameters.updateUserSettingsOptions === undefined) {
            throw new runtime.RequiredError('updateUserSettingsOptions', 'Required parameter requestParameters.updateUserSettingsOptions was null or undefined when calling createOrUpdateUserSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/user-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateUserSettingsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createOrUpdateUserSettings(requestParameters, initOverrides) {
        const response = await this.createOrUpdateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createTemporaryAccessKeyRaw(requestParameters, initOverrides) {
        if (requestParameters.createTemporaryAccessKeyOptions === null || requestParameters.createTemporaryAccessKeyOptions === undefined) {
            throw new runtime.RequiredError('createTemporaryAccessKeyOptions', 'Required parameter requestParameters.createTemporaryAccessKeyOptions was null or undefined when calling createTemporaryAccessKey.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/temporary-access`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTemporaryAccessKeyOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createTemporaryAccessKey(requestParameters, initOverrides) {
        const response = await this.createTemporaryAccessKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createTestUserRaw(requestParameters, initOverrides) {
        if (requestParameters.createTestUserOptions === null || requestParameters.createTestUserOptions === undefined) {
            throw new runtime.RequiredError('createTestUserOptions', 'Required parameter requestParameters.createTestUserOptions was null or undefined when calling createTestUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/test-user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTestUserOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createTestUser(requestParameters, initOverrides) {
        const response = await this.createTestUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createTestUserSubscriptionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling createTestUserSubscription.');
        }
        if (requestParameters.createTestUserOptions === null || requestParameters.createTestUserOptions === undefined) {
            throw new runtime.RequiredError('createTestUserOptions', 'Required parameter requestParameters.createTestUserOptions was null or undefined when calling createTestUserSubscription.');
        }
        const queryParameters = {};
        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/test-user/subscription`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTestUserOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createTestUserSubscription(requestParameters, initOverrides) {
        const response = await this.createTestUserSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async cronInfoRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/cron-info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async cronInfo(initOverrides) {
        const response = await this.cronInfoRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteAllHasOnboardedFeaturesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/delete-all-has-onboarded-features`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAllHasOnboardedFeatures(initOverrides) {
        const response = await this.deleteAllHasOnboardedFeaturesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteAllOnboardingRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/delete-all-onboarding`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAllOnboarding(initOverrides) {
        const response = await this.deleteAllOnboardingRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteHasOnboardedFeatureRaw(requestParameters, initOverrides) {
        if (requestParameters.feature === null || requestParameters.feature === undefined) {
            throw new runtime.RequiredError('feature', 'Required parameter requestParameters.feature was null or undefined when calling deleteHasOnboardedFeature.');
        }
        const queryParameters = {};
        if (requestParameters.feature !== undefined) {
            queryParameters['feature'] = requestParameters.feature;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/delete-has-onboarded-feature`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteHasOnboardedFeature(requestParameters, initOverrides) {
        const response = await this.deleteHasOnboardedFeatureRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteListUnsubscribeHeaderRaw(requestParameters, initOverrides) {
        if (requestParameters.recipient === null || requestParameters.recipient === undefined) {
            throw new runtime.RequiredError('recipient', 'Required parameter requestParameters.recipient was null or undefined when calling deleteListUnsubscribeHeader.');
        }
        const queryParameters = {};
        if (requestParameters.recipient !== undefined) {
            queryParameters['recipient'] = requestParameters.recipient;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/list-unsubscribe-recipient`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteListUnsubscribeHeader(requestParameters, initOverrides) {
        await this.deleteListUnsubscribeHeaderRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteTestUserRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling deleteTestUser.');
        }
        const queryParameters = {};
        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/test-user`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteTestUser(requestParameters, initOverrides) {
        const response = await this.deleteTestUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteUserRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteUser(initOverrides) {
        await this.deleteUserRaw(initOverrides);
    }
    /**
     */
    async expireForUserRaw(requestParameters, initOverrides) {
        if (requestParameters.updateChallengeOptions === null || requestParameters.updateChallengeOptions === undefined) {
            throw new runtime.RequiredError('updateChallengeOptions', 'Required parameter requestParameters.updateChallengeOptions was null or undefined when calling expireForUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateChallengeOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async expireForUser(requestParameters, initOverrides) {
        const response = await this.expireForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async flushExpiredInboxesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/flush-expired-inboxes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async flushExpiredInboxes(initOverrides) {
        const response = await this.flushExpiredInboxesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async freezeOwnUserRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/freeze`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async freezeOwnUser(initOverrides) {
        await this.freezeOwnUserRaw(initOverrides);
    }
    /**
     */
    async generateAndSetImapSecretsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/imap`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async generateAndSetImapSecrets(initOverrides) {
        const response = await this.generateAndSetImapSecretsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async generateAndSetSmtpImapSecretsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/smtp-imap`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async generateAndSetSmtpImapSecrets(initOverrides) {
        const response = await this.generateAndSetSmtpImapSecretsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async generateAndSetSmtpSecretsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/smtp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async generateAndSetSmtpSecrets(initOverrides) {
        const response = await this.generateAndSetSmtpSecretsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getAIPlans1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/ai-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAIPlans1(initOverrides) {
        const response = await this.getAIPlans1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getAccountRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/dto`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAccount(initOverrides) {
        const response = await this.getAccountRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getAccount1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAccount1(initOverrides) {
        const response = await this.getAccount1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getAccountImapAccessRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling getAccountImapAccess.');
        }
        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling getAccountImapAccess.');
        }
        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling getAccountImapAccess.');
        }
        const queryParameters = {};
        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }
        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }
        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/imap`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAccountImapAccess(requestParameters, initOverrides) {
        const response = await this.getAccountImapAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getAccountSmtpAccessRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling getAccountSmtpAccess.');
        }
        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling getAccountSmtpAccess.');
        }
        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling getAccountSmtpAccess.');
        }
        const queryParameters = {};
        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }
        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }
        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/smtp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAccountSmtpAccess(requestParameters, initOverrides) {
        const response = await this.getAccountSmtpAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getAllUserStripeWebhookEventsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/get-all-stripe-webhooks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAllUserStripeWebhookEvents(initOverrides) {
        const response = await this.getAllUserStripeWebhookEventsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getConnectorPlans1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/connector-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getConnectorPlans1(initOverrides) {
        const response = await this.getConnectorPlans1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getDashMetricsNotificationsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/dash-metrics/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getDashMetricsNotifications(initOverrides) {
        const response = await this.getDashMetricsNotificationsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getDashMetricsReputationRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/dash-metrics/reputation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getDashMetricsReputation(initOverrides) {
        const response = await this.getDashMetricsReputationRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getDashMetricsSubscriptionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/dash-metrics/subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getDashMetricsSubscription(initOverrides) {
        const response = await this.getDashMetricsSubscriptionRaw(initOverrides);
        return await response.value();
    }
    /**
     * Returns domain verification records for a domain
     * Get a domain DNS records as CVS
     */
    async getDomainRecordsRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getDomainRecords.');
        }
        const queryParameters = {};
        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/domain-records`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Returns domain verification records for a domain
     * Get a domain DNS records as CVS
     */
    async getDomainRecords(requestParameters, initOverrides) {
        await this.getDomainRecordsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getEmailPlans1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/email-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEmailPlans1(initOverrides) {
        const response = await this.getEmailPlans1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getErrorCodesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/error-codes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getErrorCodes(initOverrides) {
        const response = await this.getErrorCodesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getEventAggregatesSeriesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = requestParameters.startDate;
        }
        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = requestParameters.endDate;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/event-aggregates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEventAggregatesSeries(requestParameters = {}, initOverrides) {
        const response = await this.getEventAggregatesSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getGuestEmailRaw(requestParameters, initOverrides) {
        if (requestParameters.portalId === null || requestParameters.portalId === undefined) {
            throw new runtime.RequiredError('portalId', 'Required parameter requestParameters.portalId was null or undefined when calling getGuestEmail.');
        }
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling getGuestEmail.');
        }
        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling getGuestEmail.');
        }
        if (requestParameters.emailId === null || requestParameters.emailId === undefined) {
            throw new runtime.RequiredError('emailId', 'Required parameter requestParameters.emailId was null or undefined when calling getGuestEmail.');
        }
        const queryParameters = {};
        if (requestParameters.portalId !== undefined) {
            queryParameters['portalId'] = requestParameters.portalId;
        }
        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }
        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/guest/emails/{emailId}`.replace(`{${"emailId"}}`, encodeURIComponent(String(requestParameters.emailId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getGuestEmail(requestParameters, initOverrides) {
        const response = await this.getGuestEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get guest email content as HTML. For displaying emails in browser context.
     */
    async getGuestEmailHTMLRaw(requestParameters, initOverrides) {
        if (requestParameters.portalId === null || requestParameters.portalId === undefined) {
            throw new runtime.RequiredError('portalId', 'Required parameter requestParameters.portalId was null or undefined when calling getGuestEmailHTML.');
        }
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling getGuestEmailHTML.');
        }
        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling getGuestEmailHTML.');
        }
        if (requestParameters.emailId === null || requestParameters.emailId === undefined) {
            throw new runtime.RequiredError('emailId', 'Required parameter requestParameters.emailId was null or undefined when calling getGuestEmailHTML.');
        }
        const queryParameters = {};
        if (requestParameters.portalId !== undefined) {
            queryParameters['portalId'] = requestParameters.portalId;
        }
        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }
        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }
        if (requestParameters.decode !== undefined) {
            queryParameters['decode'] = requestParameters.decode;
        }
        if (requestParameters.replaceCidImages !== undefined) {
            queryParameters['replaceCidImages'] = requestParameters.replaceCidImages;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/guest/emails/{emailId}/html`.replace(`{${"emailId"}}`, encodeURIComponent(String(requestParameters.emailId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get guest email content as HTML. For displaying emails in browser context.
     */
    async getGuestEmailHTML(requestParameters, initOverrides) {
        const response = await this.getGuestEmailHTMLRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getGuestEmailsRaw(requestParameters, initOverrides) {
        if (requestParameters.portalId === null || requestParameters.portalId === undefined) {
            throw new runtime.RequiredError('portalId', 'Required parameter requestParameters.portalId was null or undefined when calling getGuestEmails.');
        }
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling getGuestEmails.');
        }
        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling getGuestEmails.');
        }
        const queryParameters = {};
        if (requestParameters.portalId !== undefined) {
            queryParameters['portalId'] = requestParameters.portalId;
        }
        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }
        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.unreadOnly !== undefined) {
            queryParameters['unreadOnly'] = requestParameters.unreadOnly;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/guest/emails`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getGuestEmails(requestParameters, initOverrides) {
        const response = await this.getGuestEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getGuestUserForPasswordRaw(requestParameters, initOverrides) {
        if (requestParameters.portalId === null || requestParameters.portalId === undefined) {
            throw new runtime.RequiredError('portalId', 'Required parameter requestParameters.portalId was null or undefined when calling getGuestUserForPassword.');
        }
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling getGuestUserForPassword.');
        }
        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling getGuestUserForPassword.');
        }
        const queryParameters = {};
        if (requestParameters.portalId !== undefined) {
            queryParameters['portalId'] = requestParameters.portalId;
        }
        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }
        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/guest/login`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getGuestUserForPassword(requestParameters, initOverrides) {
        const response = await this.getGuestUserForPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getInternalPhoneNumbersRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/internal-phone-numbers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getInternalPhoneNumbers(initOverrides) {
        const response = await this.getInternalPhoneNumbersRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getInternalSmsRaw(requestParameters, initOverrides) {
        if (requestParameters.phoneCountry === null || requestParameters.phoneCountry === undefined) {
            throw new runtime.RequiredError('phoneCountry', 'Required parameter requestParameters.phoneCountry was null or undefined when calling getInternalSms.');
        }
        const queryParameters = {};
        if (requestParameters.phoneCountry !== undefined) {
            queryParameters['phoneCountry'] = requestParameters.phoneCountry;
        }
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/internal-sms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getInternalSms(requestParameters, initOverrides) {
        const response = await this.getInternalSmsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getInvoicesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/invoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getInvoices(initOverrides) {
        const response = await this.getInvoicesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getLatestMessagesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/latest-messages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getLatestMessages(initOverrides) {
        const response = await this.getLatestMessagesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getLatestMessagesEmailRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/latest-messages/email`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getLatestMessagesEmail(initOverrides) {
        const response = await this.getLatestMessagesEmailRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getLatestMessagesSmsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/latest-messages/sms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getLatestMessagesSms(initOverrides) {
        const response = await this.getLatestMessagesSmsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getListUnsubscribeHeaderRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        if (requestParameters.sentEmailId !== undefined) {
            queryParameters['sentEmailId'] = requestParameters.sentEmailId;
        }
        if (requestParameters.recipient !== undefined) {
            queryParameters['recipient'] = requestParameters.recipient;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/list-unsubscribe-header`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getListUnsubscribeHeader(requestParameters = {}, initOverrides) {
        const response = await this.getListUnsubscribeHeaderRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrCreateAccountInboxRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/account-inbox`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrCreateAccountInbox(initOverrides) {
        const response = await this.getOrCreateAccountInboxRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getOtherAccountsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/others`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOtherAccounts(initOverrides) {
        const response = await this.getOtherAccountsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get portal description
     */
    async getPortalDescriptionRaw(requestParameters, initOverrides) {
        if (requestParameters.portalId === null || requestParameters.portalId === undefined) {
            throw new runtime.RequiredError('portalId', 'Required parameter requestParameters.portalId was null or undefined when calling getPortalDescription.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/portal-description/{portalId}`.replace(`{${"portalId"}}`, encodeURIComponent(String(requestParameters.portalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get portal description
     */
    async getPortalDescription(requestParameters, initOverrides) {
        const response = await this.getPortalDescriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getSamlConfiguration1Raw(requestParameters, initOverrides) {
        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling getSamlConfiguration1.');
        }
        const queryParameters = {};
        if (requestParameters.slug !== undefined) {
            queryParameters['slug'] = requestParameters.slug;
        }
        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }
        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/saml`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getSamlConfiguration1(requestParameters, initOverrides) {
        const response = await this.getSamlConfiguration1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUsageRecordSeriesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.usageRecordType !== undefined) {
            queryParameters['usageRecordType'] = requestParameters.usageRecordType;
        }
        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = requestParameters.startDate;
        }
        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = requestParameters.endDate;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/usage-records`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUsageRecordSeries(requestParameters = {}, initOverrides) {
        const response = await this.getUsageRecordSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUsageRecordUpdatesSeriesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.usageRecordType !== undefined) {
            queryParameters['usageRecordType'] = requestParameters.usageRecordType;
        }
        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = requestParameters.startDate;
        }
        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = requestParameters.endDate;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/usage-record-updates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUsageRecordUpdatesSeries(requestParameters = {}, initOverrides) {
        const response = await this.getUsageRecordUpdatesSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserAccountsRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling getUserAccounts.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserAccounts(requestParameters, initOverrides) {
        const response = await this.getUserAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserEventsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.names) {
            queryParameters['names'] = requestParameters.names;
        }
        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserEvents(requestParameters = {}, initOverrides) {
        const response = await this.getUserEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserForPasswordRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling getUserForPassword.');
        }
        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling getUserForPassword.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/login`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserForPassword(requestParameters, initOverrides) {
        const response = await this.getUserForPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserPlans1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/user-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserPlans1(initOverrides) {
        const response = await this.getUserPlans1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserSettingsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/user-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserSettings(initOverrides) {
        const response = await this.getUserSettingsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserStripeWebhookEventsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.names) {
            queryParameters['names'] = requestParameters.names;
        }
        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/stripe-webhooks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserStripeWebhookEvents(requestParameters = {}, initOverrides) {
        const response = await this.getUserStripeWebhookEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async grantAdminAccessToUserIdRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        if (requestParameters.message !== undefined) {
            queryParameters['message'] = requestParameters.message;
        }
        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }
        if (requestParameters.redirectDevUrl !== undefined) {
            queryParameters['redirectDevUrl'] = requestParameters.redirectDevUrl;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/grant`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async grantAdminAccessToUserId(requestParameters = {}, initOverrides) {
        const response = await this.grantAdminAccessToUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async hasMadeActionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/has-made-action`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async hasMadeAction(initOverrides) {
        const response = await this.hasMadeActionRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async hasOnboardedFeaturesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/has-onboarded-features`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async hasOnboardedFeatures(initOverrides) {
        const response = await this.hasOnboardedFeaturesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async logoutRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async logout(initOverrides) {
        await this.logoutRaw(initOverrides);
    }
    /**
     */
    async refreshApiKeyRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/apiKey`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async refreshApiKey(initOverrides) {
        const response = await this.refreshApiKeyRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async saveHasOnboardedFeatureRaw(requestParameters, initOverrides) {
        if (requestParameters.feature === null || requestParameters.feature === undefined) {
            throw new runtime.RequiredError('feature', 'Required parameter requestParameters.feature was null or undefined when calling saveHasOnboardedFeature.');
        }
        const queryParameters = {};
        if (requestParameters.feature !== undefined) {
            queryParameters['feature'] = requestParameters.feature;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/update-has-onboarded-feature`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async saveHasOnboardedFeature(requestParameters, initOverrides) {
        const response = await this.saveHasOnboardedFeatureRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedBounceRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling seedBounce.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-bounce`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedBounce(requestParameters, initOverrides) {
        await this.seedBounceRaw(requestParameters, initOverrides);
    }
    /**
     */
    async seedBounceComplaintsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.count !== undefined) {
            queryParameters['count'] = requestParameters.count;
        }
        if (requestParameters.complaints !== undefined) {
            queryParameters['complaints'] = requestParameters.complaints;
        }
        if (requestParameters.bounces !== undefined) {
            queryParameters['bounces'] = requestParameters.bounces;
        }
        if (requestParameters.recipients !== undefined) {
            queryParameters['recipients'] = requestParameters.recipients;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-bounce-and-complaints`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedBounceComplaints(requestParameters = {}, initOverrides) {
        await this.seedBounceComplaintsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async seedComplaintRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling seedComplaint.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-complaint`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedComplaint(requestParameters, initOverrides) {
        await this.seedComplaintRaw(requestParameters, initOverrides);
    }
    /**
     */
    async seedConnectorEventsRaw(requestParameters, initOverrides) {
        if (requestParameters.seedConnectorEventsOptions === null || requestParameters.seedConnectorEventsOptions === undefined) {
            throw new runtime.RequiredError('seedConnectorEventsOptions', 'Required parameter requestParameters.seedConnectorEventsOptions was null or undefined when calling seedConnectorEvents.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-connector-events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedConnectorEventsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async seedConnectorEvents(requestParameters, initOverrides) {
        const response = await this.seedConnectorEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedDeliveryStatusRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.sentEmailId !== undefined) {
            queryParameters['sentEmailId'] = requestParameters.sentEmailId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-delivery-status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedDeliveryStatus(requestParameters = {}, initOverrides) {
        await this.seedDeliveryStatusRaw(requestParameters, initOverrides);
    }
    /**
     */
    async seedDomainRaw(requestParameters, initOverrides) {
        if (requestParameters.seedDomainOptions === null || requestParameters.seedDomainOptions === undefined) {
            throw new runtime.RequiredError('seedDomainOptions', 'Required parameter requestParameters.seedDomainOptions was null or undefined when calling seedDomain.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-domain`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedDomainOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async seedDomain(requestParameters, initOverrides) {
        const response = await this.seedDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedEmailThreadRaw(requestParameters, initOverrides) {
        if (requestParameters.seedEmailThreadOptions === null || requestParameters.seedEmailThreadOptions === undefined) {
            throw new runtime.RequiredError('seedEmailThreadOptions', 'Required parameter requestParameters.seedEmailThreadOptions was null or undefined when calling seedEmailThread.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-email-thread`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedEmailThreadOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async seedEmailThread(requestParameters, initOverrides) {
        const response = await this.seedEmailThreadRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedEmailValidationRequestsRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling seedEmailValidationRequests.');
        }
        if (requestParameters.isValid === null || requestParameters.isValid === undefined) {
            throw new runtime.RequiredError('isValid', 'Required parameter requestParameters.isValid was null or undefined when calling seedEmailValidationRequests.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        if (requestParameters.isValid !== undefined) {
            queryParameters['isValid'] = requestParameters.isValid;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-email-validation-requests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedEmailValidationRequests(requestParameters, initOverrides) {
        await this.seedEmailValidationRequestsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async seedInboxEmailsRaw(requestParameters, initOverrides) {
        if (requestParameters.seedInboxOptions === null || requestParameters.seedInboxOptions === undefined) {
            throw new runtime.RequiredError('seedInboxOptions', 'Required parameter requestParameters.seedInboxOptions was null or undefined when calling seedInboxEmails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-inbox`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedInboxOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async seedInboxEmails(requestParameters, initOverrides) {
        const response = await this.seedInboxEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedInboxForwarderEventsRaw(requestParameters, initOverrides) {
        if (requestParameters.seedForwarderEventsOptions === null || requestParameters.seedForwarderEventsOptions === undefined) {
            throw new runtime.RequiredError('seedForwarderEventsOptions', 'Required parameter requestParameters.seedForwarderEventsOptions was null or undefined when calling seedInboxForwarderEvents.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-inbox-forwarder-events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedForwarderEventsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async seedInboxForwarderEvents(requestParameters, initOverrides) {
        const response = await this.seedInboxForwarderEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedInboxesRaw(requestParameters, initOverrides) {
        if (requestParameters.createInboxDto === null || requestParameters.createInboxDto === undefined) {
            throw new runtime.RequiredError('createInboxDto', 'Required parameter requestParameters.createInboxDto was null or undefined when calling seedInboxes.');
        }
        const queryParameters = {};
        if (requestParameters.functionsAs !== undefined) {
            queryParameters['functionsAs'] = requestParameters.functionsAs;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-inboxes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createInboxDto,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async seedInboxes(requestParameters, initOverrides) {
        const response = await this.seedInboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedLimitsRaw(requestParameters, initOverrides) {
        if (requestParameters.seedLimitOptions === null || requestParameters.seedLimitOptions === undefined) {
            throw new runtime.RequiredError('seedLimitOptions', 'Required parameter requestParameters.seedLimitOptions was null or undefined when calling seedLimits.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-limits`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedLimitOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedLimits(requestParameters, initOverrides) {
        await this.seedLimitsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async seedListUnsubscribeRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling seedListUnsubscribe.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-list-unsubscribe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedListUnsubscribe(requestParameters, initOverrides) {
        await this.seedListUnsubscribeRaw(requestParameters, initOverrides);
    }
    /**
     */
    async seedMissedEmailsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.n !== undefined) {
            queryParameters['n'] = requestParameters.n;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-missed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedMissedEmails(requestParameters = {}, initOverrides) {
        await this.seedMissedEmailsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async seedPaymentFailuresRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.n !== undefined) {
            queryParameters['n'] = requestParameters.n;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-payment-failure`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedPaymentFailures(requestParameters = {}, initOverrides) {
        await this.seedPaymentFailuresRaw(requestParameters, initOverrides);
    }
    /**
     */
    async seedPhoneNumbersRaw(requestParameters, initOverrides) {
        if (requestParameters.seedPhoneNumbersOptions === null || requestParameters.seedPhoneNumbersOptions === undefined) {
            throw new runtime.RequiredError('seedPhoneNumbersOptions', 'Required parameter requestParameters.seedPhoneNumbersOptions was null or undefined when calling seedPhoneNumbers.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-phone-numbers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedPhoneNumbersOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async seedPhoneNumbers(requestParameters, initOverrides) {
        const response = await this.seedPhoneNumbersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedSeriesRaw(requestParameters, initOverrides) {
        if (requestParameters.seedSeriesOptions === null || requestParameters.seedSeriesOptions === undefined) {
            throw new runtime.RequiredError('seedSeriesOptions', 'Required parameter requestParameters.seedSeriesOptions was null or undefined when calling seedSeries.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-series`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedSeriesOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async seedSeries(requestParameters, initOverrides) {
        const response = await this.seedSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedSmsRaw(requestParameters, initOverrides) {
        if (requestParameters.seedSmsOptions === null || requestParameters.seedSmsOptions === undefined) {
            throw new runtime.RequiredError('seedSmsOptions', 'Required parameter requestParameters.seedSmsOptions was null or undefined when calling seedSms.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-sms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedSmsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async seedSms(requestParameters, initOverrides) {
        const response = await this.seedSmsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedUsageRaw(requestParameters, initOverrides) {
        if (requestParameters.seedUsageOptions === null || requestParameters.seedUsageOptions === undefined) {
            throw new runtime.RequiredError('seedUsageOptions', 'Required parameter requestParameters.seedUsageOptions was null or undefined when calling seedUsage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-usage`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedUsageOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedUsage(requestParameters, initOverrides) {
        await this.seedUsageRaw(requestParameters, initOverrides);
    }
    /**
     */
    async seedWebhookResultsRaw(requestParameters, initOverrides) {
        if (requestParameters.seedWebhookResultsOptions === null || requestParameters.seedWebhookResultsOptions === undefined) {
            throw new runtime.RequiredError('seedWebhookResultsOptions', 'Required parameter requestParameters.seedWebhookResultsOptions was null or undefined when calling seedWebhookResults.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/seed-webhook-results`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.seedWebhookResultsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async seedWebhookResults(requestParameters, initOverrides) {
        const response = await this.seedWebhookResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async sendAccessLinkRaw(requestParameters, initOverrides) {
        if (requestParameters.accessOptions === null || requestParameters.accessOptions === undefined) {
            throw new runtime.RequiredError('accessOptions', 'Required parameter requestParameters.accessOptions was null or undefined when calling sendAccessLink.');
        }
        const queryParameters = {};
        if (requestParameters.isSignUp !== undefined) {
            queryParameters['isSignUp'] = requestParameters.isSignUp;
        }
        if (requestParameters.redirectDevUrl !== undefined) {
            queryParameters['redirectDevUrl'] = requestParameters.redirectDevUrl;
        }
        if (requestParameters.requestedPlanId !== undefined) {
            queryParameters['requestedPlanId'] = requestParameters.requestedPlanId;
        }
        if (requestParameters.preventNonExistingUsers !== undefined) {
            queryParameters['preventNonExistingUsers'] = requestParameters.preventNonExistingUsers;
        }
        if (requestParameters.preventMultipleAccounts !== undefined) {
            queryParameters['preventMultipleAccounts'] = requestParameters.preventMultipleAccounts;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/access`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.accessOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async sendAccessLink(requestParameters, initOverrides) {
        await this.sendAccessLinkRaw(requestParameters, initOverrides);
    }
    /**
     */
    async sendForgotLinkRaw(requestParameters, initOverrides) {
        if (requestParameters.accessOptions === null || requestParameters.accessOptions === undefined) {
            throw new runtime.RequiredError('accessOptions', 'Required parameter requestParameters.accessOptions was null or undefined when calling sendForgotLink.');
        }
        const queryParameters = {};
        if (requestParameters.redirectDevUrl !== undefined) {
            queryParameters['redirectDevUrl'] = requestParameters.redirectDevUrl;
        }
        if (requestParameters.requestedPlanId !== undefined) {
            queryParameters['requestedPlanId'] = requestParameters.requestedPlanId;
        }
        if (requestParameters.preventNonExistingUsers !== undefined) {
            queryParameters['preventNonExistingUsers'] = requestParameters.preventNonExistingUsers;
        }
        if (requestParameters.preventMultipleAccounts !== undefined) {
            queryParameters['preventMultipleAccounts'] = requestParameters.preventMultipleAccounts;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/forgot`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.accessOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async sendForgotLink(requestParameters, initOverrides) {
        await this.sendForgotLinkRaw(requestParameters, initOverrides);
    }
    /**
     */
    async setPasswordRaw(requestParameters, initOverrides) {
        if (requestParameters.setPasswordOptions === null || requestParameters.setPasswordOptions === undefined) {
            throw new runtime.RequiredError('setPasswordOptions', 'Required parameter requestParameters.setPasswordOptions was null or undefined when calling setPassword.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/password`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setPasswordOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async setPassword(requestParameters, initOverrides) {
        await this.setPasswordRaw(requestParameters, initOverrides);
    }
    /**
     */
    async setTestSmsRaw(requestParameters, initOverrides) {
        if (requestParameters.sendTestSmsOptions === null || requestParameters.sendTestSmsOptions === undefined) {
            throw new runtime.RequiredError('sendTestSmsOptions', 'Required parameter requestParameters.sendTestSmsOptions was null or undefined when calling setTestSms.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xTestId !== undefined && requestParameters.xTestId !== null) {
            headerParameters['x-test-id'] = String(requestParameters.xTestId);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/send-test-sms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendTestSmsOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async setTestSms(requestParameters, initOverrides) {
        await this.setTestSmsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async signUpRaw(requestParameters, initOverrides) {
        if (requestParameters.signUpOptions === null || requestParameters.signUpOptions === undefined) {
            throw new runtime.RequiredError('signUpOptions', 'Required parameter requestParameters.signUpOptions was null or undefined when calling signUp.');
        }
        const queryParameters = {};
        if (requestParameters.redirectDevUrl !== undefined) {
            queryParameters['redirectDevUrl'] = requestParameters.redirectDevUrl;
        }
        if (requestParameters.sendVerification !== undefined) {
            queryParameters['sendVerification'] = requestParameters.sendVerification;
        }
        if (requestParameters.requestedPlanId !== undefined) {
            queryParameters['requestedPlanId'] = requestParameters.requestedPlanId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/sign-up`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.signUpOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async signUp(requestParameters, initOverrides) {
        const response = await this.signUpRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async submitUnblockDefaultSenderRequestRaw(requestParameters, initOverrides) {
        if (requestParameters.unblockDefaultSenderRequestOptions === null || requestParameters.unblockDefaultSenderRequestOptions === undefined) {
            throw new runtime.RequiredError('unblockDefaultSenderRequestOptions', 'Required parameter requestParameters.unblockDefaultSenderRequestOptions was null or undefined when calling submitUnblockDefaultSenderRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/unblock-default-sender-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.unblockDefaultSenderRequestOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async submitUnblockDefaultSenderRequest(requestParameters, initOverrides) {
        const response = await this.submitUnblockDefaultSenderRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async submitUnfreezeRequestRaw(requestParameters, initOverrides) {
        if (requestParameters.userUnfreezeRequestOptions === null || requestParameters.userUnfreezeRequestOptions === undefined) {
            throw new runtime.RequiredError('userUnfreezeRequestOptions', 'Required parameter requestParameters.userUnfreezeRequestOptions was null or undefined when calling submitUnfreezeRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/unfreeze-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.userUnfreezeRequestOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async submitUnfreezeRequest(requestParameters, initOverrides) {
        const response = await this.submitUnfreezeRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async submitUnfreezeRequestAnonymousRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling submitUnfreezeRequestAnonymous.');
        }
        if (requestParameters.userUnfreezeRequestOptions === null || requestParameters.userUnfreezeRequestOptions === undefined) {
            throw new runtime.RequiredError('userUnfreezeRequestOptions', 'Required parameter requestParameters.userUnfreezeRequestOptions was null or undefined when calling submitUnfreezeRequestAnonymous.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/unfreeze-request-anonymous`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.userUnfreezeRequestOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async submitUnfreezeRequestAnonymous(requestParameters, initOverrides) {
        const response = await this.submitUnfreezeRequestAnonymousRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async unsubscribeEmailAddressRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.e !== undefined) {
            queryParameters['e'] = requestParameters.e;
        }
        if (requestParameters.s !== undefined) {
            queryParameters['s'] = requestParameters.s;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/unsubscribe-address`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async unsubscribeEmailAddress(requestParameters = {}, initOverrides) {
        const response = await this.unsubscribeEmailAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async unsubscribeUserIdRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling unsubscribeUserId.');
        }
        const queryParameters = {};
        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/unsubscribe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async unsubscribeUserId(requestParameters, initOverrides) {
        const response = await this.unsubscribeUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async unsubscribeUserIdRequestRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling unsubscribeUserIdRequest.');
        }
        const queryParameters = {};
        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/unsubscribe`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async unsubscribeUserIdRequest(requestParameters, initOverrides) {
        const response = await this.unsubscribeUserIdRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateAddNewContactsRaw(requestParameters, initOverrides) {
        if (requestParameters.updateAddNewContactsOptions === null || requestParameters.updateAddNewContactsOptions === undefined) {
            throw new runtime.RequiredError('updateAddNewContactsOptions', 'Required parameter requestParameters.updateAddNewContactsOptions was null or undefined when calling updateAddNewContacts.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/update-add-new-contacts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateAddNewContactsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateAddNewContacts(requestParameters, initOverrides) {
        const response = await this.updateAddNewContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateHasOnboardedRaw(requestParameters, initOverrides) {
        if (requestParameters.updateHasOnboardedOptions === null || requestParameters.updateHasOnboardedOptions === undefined) {
            throw new runtime.RequiredError('updateHasOnboardedOptions', 'Required parameter requestParameters.updateHasOnboardedOptions was null or undefined when calling updateHasOnboarded.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/update-has-onboarded`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateHasOnboardedOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateHasOnboarded(requestParameters, initOverrides) {
        const response = await this.updateHasOnboardedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updatePrimaryEmailAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.updatePrimaryEmailAddressOptions === null || requestParameters.updatePrimaryEmailAddressOptions === undefined) {
            throw new runtime.RequiredError('updatePrimaryEmailAddressOptions', 'Required parameter requestParameters.updatePrimaryEmailAddressOptions was null or undefined when calling updatePrimaryEmailAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/update-email-address`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updatePrimaryEmailAddressOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updatePrimaryEmailAddress(requestParameters, initOverrides) {
        const response = await this.updatePrimaryEmailAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async validateTemporaryAccessKeyRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling validateTemporaryAccessKey.');
        }
        if (requestParameters.endpoint === null || requestParameters.endpoint === undefined) {
            throw new runtime.RequiredError('endpoint', 'Required parameter requestParameters.endpoint was null or undefined when calling validateTemporaryAccessKey.');
        }
        const queryParameters = {};
        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }
        if (requestParameters.endpoint !== undefined) {
            queryParameters['endpoint'] = requestParameters.endpoint;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/temporary-access/validate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async validateTemporaryAccessKey(requestParameters, initOverrides) {
        const response = await this.validateTemporaryAccessKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async verifyForUserRaw(requestParameters, initOverrides) {
        if (requestParameters.challengeOptions === null || requestParameters.challengeOptions === undefined) {
            throw new runtime.RequiredError('challengeOptions', 'Required parameter requestParameters.challengeOptions was null or undefined when calling verifyForUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.challengeOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async verifyForUser(requestParameters, initOverrides) {
        const response = await this.verifyForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async waitForUserStripeWebhookEventsRaw(requestParameters, initOverrides) {
        if (requestParameters.timeout === null || requestParameters.timeout === undefined) {
            throw new runtime.RequiredError('timeout', 'Required parameter requestParameters.timeout was null or undefined when calling waitForUserStripeWebhookEvents.');
        }
        if (requestParameters.count === null || requestParameters.count === undefined) {
            throw new runtime.RequiredError('count', 'Required parameter requestParameters.count was null or undefined when calling waitForUserStripeWebhookEvents.');
        }
        const queryParameters = {};
        if (requestParameters.timeout !== undefined) {
            queryParameters['timeout'] = requestParameters.timeout;
        }
        if (requestParameters.count !== undefined) {
            queryParameters['count'] = requestParameters.count;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/wait-for-stripe-webhooks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async waitForUserStripeWebhookEvents(requestParameters, initOverrides) {
        const response = await this.waitForUserStripeWebhookEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const DeleteHasOnboardedFeatureFeatureEnum = {
    DASHBOARD: 'DASHBOARD',
    INTEGRATIONS: 'INTEGRATIONS',
    INBOXES: 'INBOXES',
    INBOXES_CREATE: 'INBOXES_CREATE',
    ORGANIZATIONS: 'ORGANIZATIONS',
    ORGANIZATIONS_CREATE: 'ORGANIZATIONS_CREATE',
    FORWARDING: 'FORWARDING',
    ALIASES: 'ALIASES',
    WEBHOOKS: 'WEBHOOKS'
};
/**
 * @export
 */
export const GetGuestEmailsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetInternalSmsPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const GetUsageRecordSeriesUsageRecordTypeEnum = {
    EMAIL_VERIFICATION_REQUEST: 'EMAIL_VERIFICATION_REQUEST',
    INBOUND_SMS: 'INBOUND_SMS',
    OUTBOUND_SMS: 'OUTBOUND_SMS',
    INBOX_CONNECTOR_SYNC: 'INBOX_CONNECTOR_SYNC',
    INBOX_CONNECTOR_SEND: 'INBOX_CONNECTOR_SEND',
    EMAIL_PLAN_INBOUND: 'EMAIL_PLAN_INBOUND',
    EMAIL_PLAN_OUTBOUND: 'EMAIL_PLAN_OUTBOUND',
    AI_TOKENS: 'AI_TOKENS',
    INBOX_CREATE: 'INBOX_CREATE',
    GUEST_USER_CREATE: 'GUEST_USER_CREATE',
    GUEST_USER_MAINTAIN: 'GUEST_USER_MAINTAIN'
};
/**
 * @export
 */
export const GetUsageRecordUpdatesSeriesUsageRecordTypeEnum = {
    EMAIL_VERIFICATION_REQUEST: 'EMAIL_VERIFICATION_REQUEST',
    INBOUND_SMS: 'INBOUND_SMS',
    OUTBOUND_SMS: 'OUTBOUND_SMS',
    INBOX_CONNECTOR_SYNC: 'INBOX_CONNECTOR_SYNC',
    INBOX_CONNECTOR_SEND: 'INBOX_CONNECTOR_SEND',
    EMAIL_PLAN_INBOUND: 'EMAIL_PLAN_INBOUND',
    EMAIL_PLAN_OUTBOUND: 'EMAIL_PLAN_OUTBOUND',
    AI_TOKENS: 'AI_TOKENS',
    INBOX_CREATE: 'INBOX_CREATE',
    GUEST_USER_CREATE: 'GUEST_USER_CREATE',
    GUEST_USER_MAINTAIN: 'GUEST_USER_MAINTAIN'
};
/**
 * @export
 */
export const GetUserEventsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetUserStripeWebhookEventsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const SaveHasOnboardedFeatureFeatureEnum = {
    DASHBOARD: 'DASHBOARD',
    INTEGRATIONS: 'INTEGRATIONS',
    INBOXES: 'INBOXES',
    INBOXES_CREATE: 'INBOXES_CREATE',
    ORGANIZATIONS: 'ORGANIZATIONS',
    ORGANIZATIONS_CREATE: 'ORGANIZATIONS_CREATE',
    FORWARDING: 'FORWARDING',
    ALIASES: 'ALIASES',
    WEBHOOKS: 'WEBHOOKS'
};
/**
 * @export
 */
export const SeedInboxesFunctionsAsEnum = {
    ALIAS: 'ALIAS',
    THREAD: 'THREAD',
    CATCH_ALL: 'CATCH_ALL',
    CONNECTOR: 'CONNECTOR',
    ACCOUNT: 'ACCOUNT',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const ValidateTemporaryAccessKeyEndpointEnum = {
    GET_EMAIL: 'GET_EMAIL',
    GET_ATTACHMENT: 'GET_ATTACHMENT',
    ALL: 'ALL'
};
